import axios from "axios";

export const updateAgencyUser = async (payload, token) => {
  try {
    const res = await axios.put("/auth/admin/user-update-details/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const updateUserPermissions = async (payload, id, token) => {
  try {
    const res = await axios.put(`auth/admin/user-role/?id=${id}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};
export const createAgencyUser = async (payload, token) => {
  try {
    const res = await axios.post("portfolio/create-portfolio/", payload, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const updatePortfolio = async (body, token) => {
  try {
    const res = await axios.put(
      `portfolio/portfolio/${body?.portfolio_id}/edit/`,
      body?.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const deletePortfolio = async (body, token) => {
  try {
    const res = await axios.delete(
      `portfolio/portfolio/${body?.portfolio_id}/edit/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const createAreaCodes = async (payload, token) => {
  try {
    const response = await axios.post(
      "portfolio/area-code-mappings/",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      "Failed to create area codes"
    );
  }
};

export const createProducts = async (payload, token) => {
  try {
    const response = await axios.post(
      "portfolio/bank-product-mappings/",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      "Failed to create product"
    );
  }
};

export const updateProfile = async (body, token, id) => {
  try {
    const res = await axios.patch(`agency/update-agency-details/${id}/`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const exportFeedbackCasesData = async (params, token) => {
  try {
    const res = await axios.get("portfolio/cases-with-feedback-export/", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const downloadUrl = res?.data?.data?.download_url;
    if (downloadUrl) {
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", res?.data?.data?.filename || "export_data.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};

export const exportAllocationData = async (params, token) => {
  try {
    const res = await axios.get("portfolio/xbucket-data-export/", {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const downloadUrl = res?.data?.data?.download_url;
    if (downloadUrl) {
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", res?.data?.data?.filename || "export_data.xlsx");
      link.setAttribute("target", "_self");
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    return res;
  } catch (err) {
    if (axios.isAxiosError(err)) {
      throw err.response?.data ?? err;
    }
    throw err;
  }
};
